import { type FC } from 'react';
import { NavLink, useLocation } from 'react-router';
import { IberiaUser } from '@Components/icons/iberia-user';
import { FaChartLine, FaFolder } from 'react-icons/fa';
import { PATHS } from '@Constants/paths.constants';
import '@Styles/footer.css';

const tabs = [
  { path: PATHS.PROFILE, label: 'Profile' },
  { path: PATHS.SCHEDULING, label: 'Scheduling' },
  { path: PATHS.DOCUMENTATION, label: 'Documentation' },
];

const Footer: FC = () => {
  const location = useLocation();

  const activeIndex = tabs.findIndex((tab) => location.pathname.startsWith(tab.path));
  const currentIndex = activeIndex >= 0 ? activeIndex : 0;

  const indicatorStyle: React.CSSProperties & { '--tab-index': number } = {
    '--tab-index': currentIndex,
  };

  return (
    <div className="footer__wrapper">
      <footer className="footer__footer">
        <div className="footer__indicator" style={indicatorStyle} />
        <NavLink
          to={PATHS.PROFILE}
          className={({ isActive }) =>
            isActive ? 'footer__item footer__item_selected' : 'footer__item'
          }
        >
          <IberiaUser className="footer__user_icon" fill="currentColor" />
          <span className="footer__text">Perfil General</span>
        </NavLink>
        <NavLink
          to={PATHS.SCHEDULING}
          className={({ isActive }) =>
            isActive ? 'footer__item footer__item_selected' : 'footer__item'
          }
        >
          <FaChartLine className="footer__icon" />
          <span className="footer__text">Programación</span>
        </NavLink>
        <NavLink
          to={PATHS.DOCUMENTATION}
          className={({ isActive }) =>
            isActive ? 'footer__item footer__item_selected' : 'footer__item'
          }
        >
          <FaFolder className="footer__icon" />
          <span className="footer__text">Documentación</span>
        </NavLink>
      </footer>
    </div>
  );
};

export default Footer;
